const messagesEn = {
  accessCodeRequired:
    'This exclusive offer requires the access code provided by your organization.',
  accessOffer: 'Access offer',
  add: 'Add',
  addOption: 'Add option',
  addOptionToAllParticipants: 'Add option to all participants',
  addParticipant: 'Add participant',
  addParticipantInfo: 'Add information for participant number {numberParticipant}',
  addToCart: 'Add to cart',
  afternoon: 'Afternoon',
  age: 'Age',
  ageBetween: 'Age must be between {min} and {max} years old.',
  appliedPromotions: 'Applied promotions',
  availability: 'Availability',
  back: 'Back',
  backToProduct: 'Back to product',
  black: '{count, plural, one {# black} other {# black}}',
  blue: '{count, plural, one {# blue} other {# blue}}',
  cancel: 'Cancel',
  cartActionCheckout: 'Checkout',
  cartActionClear: 'Empty cart',
  cartAriaOpen: 'Open cart',
  cartAriaRemoveParticipant: 'Remove this participant',
  cartAriaRemoveProduct: 'Remove this product',
  cartClearBody:
    'All products and participants will be removed. You will need to rebuild your selection.',
  cartClearConfirm: 'Empty cart',
  cartClearTitle: 'Empty the entire cart?',
  cartDialogCancel: 'Cancel',
  cartEmptyBodyDrawer: 'Browse the catalog and add your first products to start your order.',
  cartEmptyTitle: 'Your cart is empty',
  cartOptionCount: '{count, plural, one {# option} other {# options}}',
  cartParticipantCount: '{count, plural, one {# participant} other {# participants}}',
  cartRemoveProductBody:
    'All participants and options will be removed. <strong>This action cannot be undone.</strong>',
  cartRemoveProductConfirm: 'Remove this product',
  cartRemoveProductTitle: 'Remove this product from the cart?',
  cartStepLabel: 'CART',
  cartSubTotal: 'Subtotal',
  cartTitle: 'My cart',
  cartTitleParticipantCount:
    '· {count, plural, one {# participant} other {# participants}}',
  cartTotal: 'Total',
  cartTotalTaxSub: 'Incl. VAT',
  cartTrustFlexible: 'Flexible cancellation',
  cartTrustSecure: 'Secure payment',
  checkSpecialInfo: 'Check special information for this duration!',
  chooseATimeslot: 'Choose a timeslot:',
  chooseValidityCategory: 'Choose a duration of {validityCategoryName} for this product',
  close: 'Close',
  closeModal: 'Close this modal',
  code: 'Code',
  confirm: 'Confirm',
  confirmParticipants: 'Confirm participants',
  continue: 'Continue',
  date: 'Date',
  discount: 'Discount',
  discover: 'Discover',
  domainInformation: 'Domain information',
  duration: 'Duration',
  'dynamicPriceCalendar.bestPrice': 'best price',
  'dynamicPriceCalendar.chooseDayAriaLabelPrefix': 'Choose',
  'dynamicPriceCalendar.defaultCategoryName': 'adult',
  'dynamicPriceCalendar.disabledDayAriaLabelPrefix': 'Not available',
  'dynamicPriceCalendar.disclaimer':
    'Prices shown are for 1 {categoryName}, in {currency}, rounded up, may vary with availability, and confirmed when selecting participants.',
  'dynamicPriceCalendar.inRange': 'in selection',
  'dynamicPriceCalendar.monthAriaLabelPrefix': 'Calendar',
  'dynamicPriceCalendar.nextMonthAriaLabel': 'Next month',
  'dynamicPriceCalendar.originalPrice': 'original price',
  'dynamicPriceCalendar.previousMonthAriaLabel': 'Previous month',
  'dynamicPriceCalendar.selectedDate': 'selected',
  'dynamicPriceCalendar.unavailable': 'not available',
  dynamicPriceDiscount: 'You benefit from a promotional rate!',
  edit: 'Edit',
  error: 'Error',
  errorPageMessage1: "This isn't how the story was supposed to go.",
  errorPageMessage2: "We're on it and will have things back to normal shortly.",
  errorPageTitle: 'Sorry, we have a problem...',
  finalPrice: 'Final price',
  found: 'We found',
  free: 'Free',
  goBackToHome: 'Go back to home',
  green: '{count, plural, one {# green} other {# green}}',
  howOldIsTheParticipant: 'How old is this participant ?',
  includedAdvantages: 'Advantages included in this offer',
  indicativePrice: 'Indicative price for 1 participant, 1 day',
  initialPrice: 'Initial price',
  invalidProductCode: 'This code is not valid',
  kmOfSlopes: 'km of slopes',
  loading: 'Loading...',
  moreInformation: 'More information',
  morning: 'Morning',
  noData: 'No data found',
  noDateSelected: 'No date selected',
  noDomainAvailable: 'No domain available at the moment.',
  noDurationAvailable: 'No duration available at the moment.',
  noOptionSelected: 'No option selected',
  noParticipant: 'No participant',
  noProductForSelectedDuration: 'Unable to load information. Please try again.',
  noSeats: 'No more time slots available for booking.',
  options: 'Options',
  participant: 'Participant',
  participants: 'Participants',
  participantsReachedLimit: 'The maximum number of participants was reached.',
  perAdult: 'Per adult',
  priceDetails: 'Price details',
  priceSummary: 'Price summary',
  red: '{count, plural, one {# red} other {# red}}',
  refreshPage: 'Refresh page',
  remove: 'Remove',
  resort: 'Resort',
  restrictedAccess: 'Restricted access',
  results: '{count, plural, one {# result} other {# results}}',
  seats: '{count, plural, one {# seat} other {# seats}}',
  seeLess: 'See less',
  seeMore: 'See more',
  selectDates: 'Select dates',
  selectOptions: 'Select options',
  selectOrDeselectParticipants: 'Select or deselect participants:',
  showPricesFor: 'Show prices for:',
  skiLifts: 'ski lifts',
  slopes: 'slopes',
  slopesBreakdown: 'Slopes breakdown',
  specialInfo: 'Special information',
  timeslots: 'Timeslots',
  today: 'Today',
  tomorrow: 'Tomorrow',
  total: 'Total',
  unableToCalculatePrice: 'Unable to calculate a price. Please, try again later.',
  undatedProductMessage: 'No date required',
  viewDetails: 'View details',
  yearsNumber: '{count, plural, one {# year old} other {# years old}}',
  yearsRange: '{ageMin}-{ageMax} years old',
  youSaved: 'You saved',
  domain: 'Domain',
  chooseDomain: 'Choose the domain {categoryName}',
  buy: 'Buy',
  purchaseDrawerTitle: 'Your selection',
  'purchaseCallToAction.title': 'Purchase & Recharge',
  'purchaseCallToAction.subtitle':
    'Choose your dates and the number of participants for an immediate purchase or recharge.',
  'purchaseCallToAction.buttonLabel': 'Book now',
  purchaseStepConfiguration: 'CONFIGURATION',
  purchaseStepOptions: 'OPTIONS',
  closeConfirmationTitle: 'Not ready to place your order?',
  closeConfirmationDescription: 'Your current selection will be lost if you leave now.',
  closeConfirmationKeep: 'Continue my booking',
  closeConfirmationLeave: 'Leave',
  'upsell.dateChanged': 'Your stay dates have been modified',
  'upsell.days': '{count, plural, one {# day} other {# days}}',
  'upsell.included': 'Included',
  'upsell.moreInfo': 'Learn more',
  'upsell.select': 'Select',
  'upsell.title': 'Upgrade your pass',
};

export default messagesEn;
